import {useMemo} from 'react'
import {useFormContext} from 'react-hook-form'

import {useDestinationPointsCoordinates} from './use-destination-points-coordinates'
import {useSourcePointCoordinates} from './use-source-point-coordinates'

export function useOrderPointsCoordinates() {
  const {watch} = useFormContext()
  const verticalName = watch('selected_submode') || watch('vertical_name')
  const sourcePointCoordinates = useSourcePointCoordinates()
  const destinationPointCoordinates = useDestinationPointsCoordinates()

  const sourcePointHash = JSON.stringify(sourcePointCoordinates)
  const destinationPointsHash = JSON.stringify(destinationPointCoordinates)

  return useMemo(() => {
    const destinationPoints =
      verticalName === 'night' ? destinationPointCoordinates.slice(0, 1) : destinationPointCoordinates
    return [sourcePointCoordinates, ...destinationPoints]
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verticalName, sourcePointHash, destinationPointsHash])
}
